import Event from "./Event.mjs";
import appLib from "../../../libs/appLib.mjs";

//const G = window.glob;

const EventDoneStep = class extends Event {
	constructor(props) {
		super(props);
		this.clock = this.clock.bind(this);
	}

	additionalClassName() {
		let c = "step";
		if ( this.props.event?.failure ) c += " failed";
		if ( this.props.event?.data?.skip ) c += " skipped";
		if ( this.props.event?.data?.injection ) c += " injection";
		return c;
	}
	icon() {
		if ( this.props.event?.failure ) return <b title={this.props.event.failure}>❌</b>;
		if ( this.props.event?.data?.skip ) return "❌";
		return "🏁";
	}
	clock() {
		const e = this.props.event;
		if ( ! e?.id ) return '';
		if ( typeof e.data?.duration !== 'number' ) return '';
		const action = this.props.options.copione.action[e.id];
		if ( ! action?.maxtime ) return '';
		return (
			<span className={"timer"}>
				<span className={"time "+( e.data.duration > action.maxtime ? 'expired' : 'valid')}>
					{ appLib.msec2string(e.data.duration) }
				</span>
				<span className={"total"}>
					{ appLib.msec2string(action.maxtime) }
				</span>
			</span>
		);
	}
	description() {
		const e = this.props.event;
		return(<>
			{ this.clock() }
			{ e.data.name ? <b title={e.data.name}>{ e.data.name }</b> : ''}
		</>);
	}
}

export default EventDoneStep;